import { useEffect } from 'react';
import type { RefObject } from 'react';

const useScrollEventOnce = (ref: RefObject<HTMLElement>, callback: (() => void) | undefined) => {
  useEffect(() => {
    const element = ref.current;

    if (!element || !callback) return;

    let isEventTriggered = false;

    const eventHandler = () => {
      if (!isEventTriggered) {
        isEventTriggered = true;
        callback();
      }
    };

    element.addEventListener('scroll', eventHandler);

    return () => {
      if (element) {
        element.removeEventListener('scroll', eventHandler);
      }
    };
  }, [ref, callback]);
};

export default useScrollEventOnce;
